const Estado = {
    Tag: (id) => {
        for (let key in Estado) {
            if (Estado[key].est_id == id) {
                return Estado[key].tag_color
            }
        }
    },
    getTag: (id) => {
        for (let key in Estado) {
            if (Estado[key].est_id == id) {
                return Estado[key].tag_color
            }
        }
    },
    SIN_STOCK: {
        est_id: -1,
        est_nombre: "Sin stock",
        tag_color: "nj-tag c-red",
        est_codigo: "sin_stock",
    },
    INACTIVO: {
        est_id: 0,
        est_nombre: "Inactivo",
        tag_color: "nj-tag c-red",
        est_codigo: "inactivo",
    },
    ACTIVO: {
        est_id: 1,
        est_nombre: "Activo",
        tag_color: "nj-tag c-green",
        est_codigo: "activo",
    },
    REGISTRADO: {
        est_id: 2,
        est_nombre: "Registrado",
        tag_color: "",
        est_codigo: "registrado",
    },
    CREADO: {
        est_id: 3,
        est_nombre: "Creado",
        tag_color: "",
        est_codigo: "creado",
    },
    POR_APROBAR: {
        est_id: 4,
        est_nombre: "Por aprobar",
        tag_color: "",
        est_codigo: "por_aprobar",
    },
    APROBADO: {
        est_id: 5,
        est_nombre: "Aprobado",
        tag_color: "",
        est_codigo: "aprobado",
    },
    DESAPROBADO: {
        est_id: 6,
        est_nombre: "Desaprobado",
        tag_color: "",
        est_codigo: "desaprobado",
    },
    EMITIDO: {
        est_id: 7,
        est_nombre: "Emitido",
        tag_color: "",
        est_codigo: "emitido",
    },
    CANCELADO: {
        est_id: 8,
        est_nombre: "Cancelado",
        tag_color: "",
        est_codigo: "cancelado",
    },
    DEPOSITADO: {
        est_id: 9,
        est_nombre: "Depositado",
        tag_color: "",
        est_codigo: "depositado",
    },
    PAGO_PARCIAL: {
        est_id: 10,
        est_nombre: "Pago_parcial",
        tag_color: "",
        est_codigo: "pago_parcial",
    },
    PAGADO: {
        est_id: 11,
        est_nombre: "Pagado",
        tag_color: "",
        est_codigo: "pagado",
    },
    ASIGNADO: {
        est_id: 12,
        est_nombre: "Asignado",
        tag_color: "",
        est_codigo: "asignado",
    },
    POR_DEVOLVER: {
        est_id: 23,
        est_nombre: "Por devolver",
        tag_color: "",
        est_codigo: "por_devolver",
    },
    ELIMINADO: {
        est_id: 24,
        est_nombre: "Eliminado",
        tag_color: "nj-tag c-red",
        est_codigo: "eliminado",
    },
    INGRESO_CONFIRMADO: {
        est_id: 25,
        est_nombre: "Ingreso confirmado",
        tag_color: "nj-tag c-blue",
        est_codigo: "ingreso_confirmado",
    },
    INGRESO_PARCIAL: {
        est_id: 26,
        est_nombre: "Ingreso parcial",
        tag_color: "nj-tag c-red",
        est_codigo: "ingreso_parcial",
    },
}

export default Estado